import React from "react";
import OverlayContainer from "./OverlayContainer";
import ImageStrip from "./ImageStrip";
import Logo from "./Logo";
import Breadcrumb, {BreadcrumbItem} from "./Breadcrumb";

export class TopBarWithBreadcrumbs extends React.Component<{
    backgroundUrl: string | undefined,
    items: BreadcrumbItem[]
}> {
    render() {
        return <OverlayContainer background={<ImageStrip src={this.props.backgroundUrl}/>}
                                 height={"250px"}
                                 align={"flex-start"} position={"flex-start"}>
            <Logo/>
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    pointerEvents: "auto",
                }}
            >
                <div style={{display: "block", width: "100%"}}>
                    <div style={{display: "block", width: "100%"}}>
                        <Breadcrumb items={this.props.items}/>
                    </div>
                    <div
                        style={{
                            display: "block",
                            height: "30px",
                            width: "100%",
                        }}></div>
                    <div
                        style={{
                            display: "block",
                            height: "3px",
                            width: "100%",
                            background: "linear-gradient(360deg, rgba(18, 18, 18, 1) 0%, rgba(18, 18, 18, 0) 100%)",
                        }}></div>
                </div>
            </div>
        </OverlayContainer>;
    }
}